import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Odd } from "../models/odd.interface";
import { ApiService } from "./api.service";

@Injectable({
  providedIn: "root",
})
export class OddService {
  constructor(private apiService: ApiService) {}

  getOdds(): Observable<Odd[]> {
    return this.apiService.get("/gandadmin/odds");
  }
}
